import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 820px) and (min-width: 600px) {
    width: auto;
    padding-left: 73px;
    padding-right: 73px;
    padding-top: 30px;
  }

  @media screen and (max-width: 600px) {
    width: auto;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
  }
`
